var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("kramp")))]),
                      _vm.hasModule
                        ? [
                            _vm.job
                              ? _c("w-progress-linear", {
                                  staticClass: "progress",
                                  attrs: { value: _vm.jobProgress },
                                })
                              : _vm._e(),
                            _c(
                              "w-card-content",
                              [
                                _c(
                                  "w-row",
                                  [
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12" } },
                                      [
                                        _c(
                                          "app-contact-search-with-browse-and-create",
                                          {
                                            attrs: {
                                              fancy: "",
                                              "group-id": 2,
                                              label: _vm.$ct("kramp-supplier"),
                                              value: _vm.krampSupplier,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.setKrampSupplier(
                                                  $event
                                                )
                                              },
                                            },
                                          }
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12" } },
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            label: _vm.$ct("ftp-host"),
                                            fancy: "",
                                          },
                                          model: {
                                            value: _vm.config.Host,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.config, "Host", $$v)
                                            },
                                            expression: "config.Host",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12", md: "6" } },
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            label: _vm.$ct("username"),
                                            fancy: "",
                                          },
                                          model: {
                                            value: _vm.config.Username,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "Username",
                                                $$v
                                              )
                                            },
                                            expression: "config.Username",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12", md: "6" } },
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            password: "",
                                            label: _vm.$ct("password"),
                                            fancy: "",
                                          },
                                          model: {
                                            value: _vm.config.Password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "Password",
                                                $$v
                                              )
                                            },
                                            expression: "config.Password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-card-actions",
                              [
                                _c("w-spacer"),
                                _c(
                                  "w-button",
                                  {
                                    attrs: {
                                      disabled: _vm.saveButtonDisabeled,
                                      icon: _vm.saveIcon,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveButtonClicked()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.saveButtonText))]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _c(
                            "w-card-content",
                            [
                              _c("app-missing-module", {
                                attrs: { "module-id": _vm.krampModule },
                              }),
                            ],
                            1
                          ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }